/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe !== 'function' || !window.theme || !window.theme.PUB_SUB_EVENTS) return;

    subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function ({ data }) {
      var variant = data && data.variant;
      if (!variant) return;

      // Update size cells
      if (Array.isArray(variant.options)) {
        var cells = document.querySelectorAll('[data-variant-option-index]');
        cells.forEach(function (cell) {
          var indexAttr = cell.getAttribute('data-variant-option-index');
          var index = parseInt(indexAttr, 10);
          if (!index || !variant.options[index - 1]) return;
          cell.textContent = variant.options[index - 1];
        });
      }

      // Update price cell
var priceCell = document.querySelector('[data-variant-price]');
if (priceCell && typeof window.theme.formatMoney === 'function') {
  var price = variant.price || 0;
  var compareAt = variant.compare_at_price || 0;

  var formattedPrice = window.theme.formatMoney(price, theme.moneyFormat);

  // Only show compare-at when it's higher than the price (i.e. on sale)
  if (compareAt > price) {
    var formattedCompare = window.theme.formatMoney(compareAt, theme.moneyFormat);
    priceCell.innerHTML = formattedPrice + ' <s>' + formattedCompare + '</s>';
  } else {
    priceCell.textContent = formattedPrice;
  }
}
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// Functionaliteit voor youtube shorts in popup
document.addEventListener('click', function(e) {
  const link = e.target.closest('a');

  if (!link) return;

  // Check of de link een YouTube Short is
  if (link.href.includes('youtube.com/shorts')) {
    e.preventDefault();

    const videoId = link.href.split('/shorts/')[1].split('?')[0];

    // Popup tonen
    const popup = document.getElementById('video-popup');
    const iframe = document.getElementById('video-frame');

    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    popup.style.display = 'block';
  }
});

// Functionaliteit voor youtube shorts popup close
document.getElementById('close-video').addEventListener('click', function() {
  const popup = document.getElementById('video-popup');
  const iframe = document.getElementById('video-frame');

  popup.style.display = 'none';
  iframe.src = '';
});

